<template lang="pug">
  .code-data
    .panel.panel-default
      .panel-body
        .kezzler-codes.form-horizontal(v-if="codeType === 'KZ'")
          .form-group
            label.col-sm-4.control-label Name
            .col-sm-8
              input.form-control(v-model="kzExpansion.name" placeholder="Expansion Name")
          .form-group
            label.col-sm-4.control-label Count
            .col-sm-8
              input.form-control(v-model="kzExpansion.codeCount" type="number" placeholder="Count" :disabled="predefinedExpansionCount")
          .form-group
            label.col-sm-4.control-label Configuration
            .col-sm-8
              v-select(v-model="codeConfig" :options="codeConfigs" label="description" placeholder="Code Configuration")
          .form-group
            label.col-sm-4.control-label Length
            .col-sm-8
              input.form-control(type="number" v-model="kzExpansion.codeLength" :disabled="!codeConfigSelected" placeholder="Code Length")
              .red(v-if="kzExpansion.codeLength && kzExpansion.codeLength < minimumCodeLength || kzExpansion.codeLength > maximumCodeLength") Min length: {{minimumCodeLength}} / Max length {{maximumCodeLength}}
          .form-group
            label.col-sm-4.control-label Type
            .col-sm-8
              v-select(v-model="shadowType" :options="shadowTypes" label="name" placeholder="Code Type")


        .external-codes.form-horizontal(v-if="codeType === 'EXT'")
          .form-group
            label.col-sm-4.control-label Name
            .col-sm-8
              input.form-control(v-model="extExpansion.name" placeholder="Expansion Name")
          .form-group
            label.col-sm-4.control-label Codes
            .col-sm-8
              input(@change="onFileChange" type="file")
              .red(v-if="isEqualCount") The expansions has to be of equal length - {{predefinedExpansionCount}}
              .red(v-if="fileTypeError") {{fileTypeError}}
          .form-group
            label.col-sm-4.control-label Configuration
            .col-sm-8
              v-select(v-model="codeConfig" :options="codeConfigs" label="description" placeholder="Code Configuration")
          .form-group
            label.col-sm-4.control-label Type
            .col-sm-8
              v-select(v-model="shadowType" :options="shadowTypes" label="name" placeholder="Code Type")

      .panel-footer
        .text-right
          span.error-handling {{errorMsg}}
          button.btn.btn-primary(@click="appendCodeData()" :disabled="!isValid || !validCodeCount || fileTypeError") Next
          button.btn.btn-default.ml10(@click="removeCurrentCodeData()") Cancel
</template>

<script>
import vSelect from 'vue-select'
import Core from '@/service/apis/Core'
import ErrorEmiter from '@/components/common/ErrorEmiter'

export default {
  extends: ErrorEmiter,
  props: {
    codeType: {
      required: true
    },
    predefinedExpansionCount: {
      type: Number
    }
  },
  data() {
    return {
      kzExpansion: this.initKzData(),
      extExpansion: this.initExtData(),
      shadowTypes: [{
        name: 'administrative',
        value: 'ADMINISTRATIVE'
      }, {
        name: 'consumer',
        value: 'CONSUMER'
      }],
      shadowType: null,
      codeLengthErrorMsg: null,
      codeConfigs: [],
      codeConfig: null,
      minimumCodeLength: null,
      maximumCodeLength: null,
      errorMsg: null,
      fileTypeError: null
    }
  },
  created() {
    this.getCodeConfigs()
  },
  methods: {
    initKzData() {
      return {
        codeCount: this.predefinedExpansionCount ? this.predefinedExpansionCount : null,
        codeConfiguration: null,
        codeLength: null,
        name: null
      }
    },
    initExtData() {
      return {
        codes: null,
        codeConfiguration: null,
        name: null
      }
    },
    validateFileExtension(file) {
      if (!/(\.txt|\.csv)$/i.test(file)) {
        this.fileTypeError = 'Invalid text file type'
      } else {
        this.fileTypeError = null
      }
    },
    onFileChange(e) {
      const files = e.target.files || e.dataTransfer.files
      if (!files.length) { return }
      this.validateFileExtension(files[0].name)
      this.createExternalCodes(files[0])
    },
    createExternalCodes(file) {
      const reader = new FileReader()
      const BY_NEWLINE_OR_COMMA = /[\n\r\s,]+/

      reader.onload = () => {
        this.extExpansion.codes = reader.result.split(BY_NEWLINE_OR_COMMA).filter((c) => c.length !== 0)
      }
      reader.readAsText(file)
    },
    getExpansionCount() {
      if (this.extExpansion.codes) {
        return this.extExpansion.codes.length
      } if (this.kzExpansion.codeCount) {
        return this.kzExpansion.codeCount
      }
    },
    removeCurrentCodeData() {
      this.$emit('removeCurrentCodeData')
    },
    appendCodeData() {
      const req = this.codeType === 'KZ' ? this.kzExpansion : this.extExpansion
      req.codeConfiguration = this.codeConfig
      req.codeType = this.shadowType ? this.shadowType.value : null
      this.$emit('codeData', req)
    },
    getCodeConfigs() {
      Core.listCodeConfigs({ size: 1000 })
        .then((resp) => {
          if (this.codeType === 'KZ') {
            this.codeConfigs = resp.data.content.filter((c) => c.type === 'KZ')
          } else if (this.codeType === 'EXT') {
            this.codeConfigs = resp.data.content.filter((c) => c.type === 'EXT')
          }
        })
        .catch((e) => {
          this.errorMsg = this.emitError(e)
        })
    }
  },
  watch: {
    codeConfig() {
      if (this.codeConfig) {
        this.maximumCodeLength = this.codeConfig.maxLength
        this.minimumCodeLength = this.codeConfig.minLength
        this.defaultLength = this.codeConfig.defaultLength
        this.kzExpansion.codeLength = this.defaultLength
      }
    },
    codeType() {
      this.kzExpansion = this.initKzData()
      this.extExpansion = this.initExtData()
      this.codeConfig = null
      this.getCodeConfigs()
    },
    codeConfigSelected() {
      if (!this.codeConfig) {
        this.kzExpansion.codeLength = null
      }
    }
  },
  computed: {
    isEqualCount() {
      if (this.predefinedExpansionCount && (this.kzExpansion.codeCount || this.extExpansion.codes)) {
        return this.predefinedExpansionCount !== this.getExpansionCount()
      }
      return false
    },
    validCodeCount() {
      if (this.codeType === 'KZ') {
        return this.kzExpansion.codeCount > 0
      }
      return this.extExpansion.codes.length > 0
    },
    isValid() {
      if (this.codeType === 'KZ') {
        const kz = this.kzExpansion
        return kz.codeCount && this.codeConfig && kz.codeLength && this.shadowType
      }
      const ext = this.extExpansion
      return !this.isEqualCount && ext.codes && this.codeConfig && this.shadowType
    },
    codeConfigSelected() {
      if (!this.codeConfig) {
        return false
      }
      return true
    }
  },
  components: {
    vSelect
  }
}
</script>

<style lang="scss">
.code-data {
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/core/order/code/components/CodeData.vue